<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:status="{ row }">
        <el-tag size="mini" :type="row.orgStatus === 'Y' ? 'light' : 'warning'">
          {{ row.v_orgStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'detail',
                  code: row.orgCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="allow('M')"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'edit',
                  code: row.orgCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-show="row.orgStatus === 'Y'"
            v-if="allow('D')"
          >
            <i class="el-icon-delete tool-btn" @click="del(row.orgCode)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  components: {},
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'left',
          fixed: 'left',
          width: 110,
          slots: {
            default: 'opt',
          },
        },
        {
          title: this.$l('table_label_org_no') || '机构编号',
          field: 'orgNo',
          width: 180,
          align: 'center',
          fixed: 'left',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('table_label_org_name') || '机构名称',
          field: 'orgName',
          width: 250,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('table_label_province') || '省份',
          field: 'provinceName',
          width: 150,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('table_label_city') || '城市',
          field: 'cityName',
          width: 150,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('table_label_district') || '区县',
          field: 'districtName',
          width: 150,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('table_label_detailed_address') || '详细地址',
          field: 'orgAddress',
          minWidth: 350,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('INDEX.table_label_State') || '状态',
          width: 80,
          align: 'center',
          headerAlign: 'center',
          slots: { default: 'status' },
        },
        {
          title: this.$l('INDEX.table_label_created_by') || '创建人',
          field: 'createByName',
          width: 100,
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          title: this.$l('INDEX.table_label_created_date') || '创建时间',
          field: 'createDate',
          width: 170,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          title: this.$l('INDEX.table_label_modified_by') || '修改人',
          field: 'modifyByName',
          width: 100,
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          title: this.$l('INDEX.table_label_modification_date') || '修改时间',
          field: 'modifyDate',
          width: 170,
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
      ],
    }
  },
  methods: {
    del(orgCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.sysOrganizationDelApi({ orgCode }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },
  },
}
</script>
